import axios from '../../axios'

const state = {
  listings: [],
  pagination: {},
  filters: {},
  categories: [],
  showClosedEnabled: false,
  selected: null,
  transactions: [],
  transactionPagination: {},
  selectedTransaction: null,
  loading: false,
  error: ''
}

const mutations = {
  setLoading (state, value) { state.loading = value },
  setError (state, value) { state.error = value },
  setListings (state, response) {
    state.listings = response.data || []
    state.pagination = response.meta || {}
    state.categories = response.meta_data?.categories || []
    state.showClosedEnabled = response.meta_data?.show_closed_enabled === true
  },
  setSelected (state, value) { state.selected = value },
  setTransactions (state, response) {
    state.transactions = response.data || []
    state.transactionPagination = response.meta || {}
  },
  setSelectedTransaction (state, value) { state.selectedTransaction = value }
}

const actions = {
  async fetchPlates ({ commit }, filters = {}) {
    commit('setLoading', true)
    commit('setError', '')
    try {
      const response = await axios.get('/page/plates', { params: filters })
      commit('setListings', response.data)
      return response
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Unable to load plate auctions.')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  async fetchPlate ({ commit }, slug) {
    commit('setLoading', true)
    commit('setError', '')
    try {
      const response = await axios.get(`/page/plate/${slug}`)
      commit('setSelected', response.data.data)
      return response.data.data
    } catch (error) {
      commit('setError', error.response?.data?.message || 'Unable to load this plate auction.')
      throw error
    } finally {
      commit('setLoading', false)
    }
  },
  async placeBid ({ dispatch }, { slug, productId, amount }) {
    const response = await axios.post('/bid', { product_id: productId, amount, less_5: 0 })
    await dispatch('fetchPlate', slug)
    return response
  },
  async fetchTransactions ({ commit }, page = 1) {
    commit('setLoading', true)
    try {
      const response = await axios.get('/plate-transactions', { params: { page } })
      commit('setTransactions', response.data)
      return response
    } finally {
      commit('setLoading', false)
    }
  },
  async fetchTransaction ({ commit }, id) {
    commit('setLoading', true)
    try {
      const response = await axios.get(`/plate-transactions/${id}`)
      commit('setSelectedTransaction', response.data.data)
      return response.data.data
    } finally {
      commit('setLoading', false)
    }
  },
  async commissionPaymentLink ({ dispatch }, id) {
    const response = await axios.post(`/plate-transactions/${id}/commission-payment-link`)
    await dispatch('fetchTransaction', id)
    return response.data.data
  },
  async submitTransactionAction ({ dispatch }, { id, endpoint, payload, multipart = false }) {
    await axios.post(`/plate-transactions/${id}/${endpoint}`, payload, multipart ? { headers: { 'Content-Type': 'multipart/form-data' } } : undefined)
    return dispatch('fetchTransaction', id)
  }
}

export default {
  namespaced: true,
  name: 'plates',
  state,
  mutations,
  actions
}
